import styled from 'styled-components';
import { COLOR_GREY_DARKER } from '../../../config';

export const HeaderContainer = styled.div`
    position: relative;
    z-index: 60;
    box-shadow: 0 0 0.8rem rgba(0, 0, 0, 0.5);

    svg {
        width: 100%;

        text {
            fill: #999999;
            font-family: Daimler CS;
            font-weight: 400;
        }
    }
`;

export const LanguagePickerContainer = styled.div`
    position: absolute;
    right: 4%;
    top: 0;
    display: flex;
    transform: translateY(10%);
`;

export const LanguagePickerFlag = styled.div`
    height: 4.5rem;
    width: 4.5rem;
    display: flex;
    transform: translateY(3%);
`;

export const LanguagePickerSelect = styled.select`
    background: none;
    border: none;
    color: inherit;
    width: 7rem;
    color: ${COLOR_GREY_DARKER};
    font-size: 1rem;
`;
